export default "__VITE_ASSET__DGsExLKG__"